module.exports = __webpack_public_path__ + "static/media/wx.e41667b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/wx.png
// module id = 5
// module chunks = 0